<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit, invalid }">
    <div class="box">
      <div class="block">
        <label class="label">{{ nameInputLabel }}</label>
        <div class="is-flex">
          <BInputWithValidation
            rules="required|max:50"
            type="text"
            v-model="routeCopy.name"
            style="width: 100%"
            class="mr-3"
          />
          <b-button
            @click="routeCopy.default_visible = !routeCopy.default_visible"
            :icon-right="routeCopy.default_visible ? 'eye' : 'eye-slash'"
          ></b-button>
        </div>
      </div>
      <div class="block">
        <BInputWithValidation
          rules="required|max:250"
          type="text"
          label="Search Title"
          v-model="routeCopy.search_title"
        />
      </div>
      <!-- Hide icon, url, filter, and tag input if the route is a label -->
      <div :class="{ 'is-invisible': routeCopy.label }">
        <div class="block">
          <IconPicker label="Icon" v-model="routeCopy.icon" />
        </div>
        <div class="block">
          <BInputWithValidation
            rules="max:255"
            type="text"
            label="Tableau-URL"
            v-model="routeCopy.link"
          />
        </div>
        <div class="block">
          <BInputWithValidation
            rules="max:500"
            type="text"
            label="Tableau-Filter"
            v-model="routeCopy.filter"
          />
        </div>
        <div class="block">
          <RouteTagInput
            v-model="routeCopy.tags"
            :tagDropup="tagDropup"
          ></RouteTagInput>
        </div>
      </div>
    </div>
    <div class="block" v-if="error || tagError">
      <b-message type="is-danger">
        <span v-html="error || tagError" />
      </b-message>
    </div>
    <div class="is-flex" style="justify-content: end">
      <div class="buttons">
        <b-button @click="$emit('close')" v-if="showCloseBtn">
          Schließen
        </b-button>
        <b-button
          type="is-gold"
          :disabled="invalid"
          @click="handleSubmit(submit)"
        >
          Speichern
        </b-button>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import { mapGetters } from "vuex";

import BInputWithValidation from "@/components/inputs/BInputWithValidation.vue";
import RouteTagInput from "@/components/editProduct/RouteTagInput.vue";
import IconPicker from "@/components/inputs/IconPicker.vue";

export default {
  name: "RouteEdit",
  components: {
    BInputWithValidation,
    RouteTagInput,
    IconPicker
  },
  props: {
    route: {
      required: true
    },
    showCloseBtn: {
      type: Boolean,
      default: false
    },
    tagDropup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      routeCopy: {
        ...this.route,
        filter: this.route.filter
          ? decodeURI(this.route.filter)
          : this.route.filter
      },
      originalName: this.route.name,
      nameUpdated: false
    };
  },
  computed: {
    ...mapGetters({
      error: "product/route/error",
      tagError: "tag/error"
    }),
    nameInputLabel() {
      return this.routeCopy.label ? "Text" : "Seitentitel";
    }
  },
  watch: {
    route: {
      deep: true,
      handler(newVal) {
        this.routeCopy = {
          ...newVal,
          filter: this.route.filter ? decodeURI(newVal.filter) : newVal.filter
        };
        this.originalName = newVal.name;
      }
    },
    "routeCopy.name": {
      handler(newName) {
        this.nameUpdated = newName !== this.originalName;
      }
    }
  },
  methods: {
    submit() {
      const { name, tags, id, ...data } = this.routeCopy;

      const payload = { ...data };

      if (payload.filter) payload.filter = encodeURI(payload.filter);

      if (id) {
        payload.id = id;
      }

      if (this.nameUpdated) {
        payload.name = name;
      }

      if (tags && tags.length) {
        payload.tags = this.tagsForUpdate(tags);
      }

      if (this.showCloseBtn) {
        this.$emit("close");
      }

      this.$emit("submit", payload);
    },
    tagsForUpdate(tags) {
      // Convert array of tag object into array of tag id
      return tags.map(tag => tag.id);
    }
  }
};
</script>

<style>
</style>
